import { Routes } from '@angular/router';
import { ErrorPageComponent } from './error-page.component';

export const ERROR_PAGES_ROUTES: Routes = [
	{
		path: '400',
		component: ErrorPageComponent,
		data: { code: 400, message: 'error.error-400' },
	},
	{
		path: '401',
		component: ErrorPageComponent,
		data: { code: 401, message: 'error.error-401' },
	},
	{
		path: '403',
		component: ErrorPageComponent,
		data: { code: 403, message: 'error.error-403' },
	},
	{
		path: '404',
		component: ErrorPageComponent,
		data: { code: 404, message: 'error.error-404' },
	},
	{
		path: '408',
		component: ErrorPageComponent,
		data: { code: 408, message: 'error.expired-token' },
	},
	{
		path: '500',
		component: ErrorPageComponent,
		data: { code: 'Server Error', message: 'error.error-500' },
	},
];
